import * as React from "react";
import { CaseRunCreateModelBase } from "@app/api2/api";
import { HandlerRegistry } from "./RunTypes/HandlerRegistry";

interface IInformationProps {
    model: CaseRunCreateModelBase;
    onComplete: (values: any) => void;
    router: any;
    rangeOfContributors: boolean;
}

class InformationState {
    initialValues: {};
    populationOptions: any[];
}

export class Information extends React.Component<IInformationProps, InformationState> {
    
    constructor(props, context) {
        super(props, context);
    }


    render() {
        const handler = HandlerRegistry.getRunTypeHandler(this.props.model.runType);
        return (
            handler.renderInformation(this.props.model, this.props.onComplete, this.props.router, this.props.rangeOfContributors)
        );
    }
}